import gsap from 'gsap'

import {
  buttonRevealAnimation,
  fadeImageAnimation,
  fadeInAnimation,
  SharedAnimation,
  titleRevealAnimation
} from './shared'
import { Animation } from '@/types'

export const tripleSection = ({
  node,
  reverse,
  mobile,
  context
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const image = selector('[data-motion-image]')[0]
  const secondaryImage = selector('[data-motion-secondary-image]')[0]
  const bigTitle = selector('[data-motion-big-title]')[0]
  const title = selector('[data-motion-title]')[0]
  const subtitle = selector('[data-motion-subtitle]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let imageAnimation: SharedAnimation
  if (image) {
    imageAnimation = fadeImageAnimation(image)
    timeline.add(imageAnimation.timeline, '<')
  }

  let secondaryImageAnimation: SharedAnimation
  if (secondaryImage) {
    secondaryImageAnimation = fadeImageAnimation(secondaryImage)
    timeline.add(secondaryImageAnimation.timeline, '<0.1')
  }

  let bigTitleAnimation: SharedAnimation
  if (bigTitle) {
    bigTitleAnimation = titleRevealAnimation(bigTitle, reverse)
    timeline.add(bigTitleAnimation.timeline, '<')
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = titleRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<')
  }

  let subtitleAnimation: SharedAnimation
  if (subtitle) {
    subtitleAnimation = titleRevealAnimation(subtitle, reverse)
    timeline.add(subtitleAnimation.timeline, '<')
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = fadeInAnimation(paragraph)
    timeline.add(paragraphAnimation.timeline, '<')
  }

  return () => {
    if (imageAnimation) {
      imageAnimation.revert()
    }
    if (secondaryImageAnimation) {
      secondaryImageAnimation.revert()
    }
    if (bigTitleAnimation) {
      bigTitleAnimation.revert()
    }
    if (titleAnimation) {
      titleAnimation.revert()
    }
    if (subtitleAnimation) {
      subtitleAnimation.revert()
    }
    if (paragraphAnimation) {
      paragraphAnimation.revert()
    }
  }
}
